import { render } from "./LanguageSelector.vue?vue&type=template&id=54207aba"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/LanguageSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54207aba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54207aba', __exports__)) {
    api.reload('54207aba', __exports__)
  }
  
  module.hot.accept("./LanguageSelector.vue?vue&type=template&id=54207aba", () => {
    api.rerender('54207aba', render)
  })

}


export default __exports__